import { useEffect } from 'react';
import { useObserver, useObserverReturningStore } from '../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../Legacy';
import { ReadStore } from '../concepts/revive/ReadStore';
import { useResolve } from './Container';

export interface AppLocationLayer {
    readonly name: string;
    readonly value: string;
    readonly label?: string;
}

export class AppLocation extends ReadStore<AppLocationLayer[]> implements Iterable<AppLocationLayer> {

    protected state: AppLocationLayer[] = [];

    public get(name: string) {
        for (const ly of this.state) {
            if (ly.name === name) {
                return ly.value;
            }
        }
        return null;
    }

    public at(index: number) {
        return this.state[index];
    }

    public includes(name: string, value?: string) {
        for (const ly of this.state) {
            if (ly.name === name && (ly.value === value || !value)) {
                return true;
            }
        }
        return false;
    }

    public push(layer: AppLocationLayer): this {
        this.mutate(x => x.push(layer));
        return this;
    }

    public pop(): this {
        this.mutate(x => x.pop());
        return this;
    }

    [Symbol.iterator](): Iterator<AppLocationLayer> {
        return this.getState()[Symbol.iterator]();
    }
}

export const useLocationScope = (name: string, value?: string, label?: string) => {
    const location = useResolve(AppLocation);
    useEffect(() => {
        value = value || name;
        location.push({ name, value, label });
        return () => void (location.pop());
    }, [name, value, label]);
};

export const UseLocationScope: LFC<{ name: string, value?: string, label?: string }> = ({ name, value, label }) => {
    useLocationScope(name, value, label);
    return null;
};

export const SetTitleUsingAppLocation: LFC = () => {
    const layers = useObserver(useResolve(AppLocation));
    const title = layers.map(x => x.label).filter(x => !!x);
    document.title = ['Ludi'].concat(title).reverse().join(' | ');
    return null;
};

export const useLocationValue = (name: string) => {
    const location = useObserverReturningStore(useResolve(AppLocation));
    return location.get(name);
};
